module.exports = __webpack_public_path__ + "img/playlistFilesInMOH.ba5db2b4.png";